import SocialIcons from "./SocialIcons";
import { useI18n } from "../../lib/i18n";

export default function Footer() {
    const { t } = useI18n();
    const s = t.footer;
    return (
        <footer
            className="relative border-t border-white/[0.06] bg-[#050505] py-14"
            data-testid="site-footer"
        >
            <div className="container-x">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <span className="w-2 h-2 rounded-full bg-[#E55B13]" />
                            <span className="font-heading text-sm tracking-[0.24em] font-medium">
                                FTAKLAKIS MEDIA
                            </span>
                        </div>
                        <p className="mt-5 font-body text-white/55 text-sm leading-relaxed max-w-sm">
                            {s.tagline}
                        </p>
                    </div>

                    <div className="md:col-span-4">
                        <div className="font-mono text-[11px] tracking-[0.24em] uppercase text-white/40 mb-4">
                            {s.studio}
                        </div>
                        <ul className="space-y-2 font-body text-sm text-white/70">
                            <li>
                                <a
                                    href="#industries"
                                    className="hover:text-[#E55B13] transition-colors"
                                    data-testid="footer-link-industries"
                                >
                                    {s.links.industries}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#services"
                                    className="hover:text-[#E55B13] transition-colors"
                                    data-testid="footer-link-services"
                                >
                                    {s.links.services}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#pricing"
                                    className="hover:text-[#E55B13] transition-colors"
                                    data-testid="footer-link-pricing"
                                >
                                    {s.links.pricing}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#portfolio"
                                    className="hover:text-[#E55B13] transition-colors"
                                    data-testid="footer-link-work"
                                >
                                    {s.links.work}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#contact"
                                    className="hover:text-[#E55B13] transition-colors"
                                    data-testid="footer-link-contact"
                                >
                                    {s.links.contact}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-mono text-[11px] tracking-[0.24em] uppercase text-white/40 mb-4">
                            {s.follow}
                        </div>
                        <SocialIcons size="lg" testidPrefix="footer-social" />
                        <div className="mt-6 font-mono text-[11px] tracking-[0.22em] uppercase text-white/40">
                            {s.location}
                        </div>
                    </div>
                </div>

                <div className="hairline my-10" />

                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <div className="font-mono text-[11px] tracking-[0.24em] text-white/40 uppercase">
                        © {new Date().getFullYear()} FTAKLAKIS MEDIA ·{" "}
                        {s.copyright}
                    </div>
                    <a
                        href="#top"
                        className="font-mono text-[11px] tracking-[0.24em] text-white/60 hover:text-[#E55B13] transition uppercase"
                        data-testid="footer-back-top"
                    >
                        {s.backToTop}
                    </a>
                </div>
            </div>
        </footer>
    );
}
